import React from 'react';
import CustomCheckbox from 'components/CustomCheckbox/CustomCheckbox';
import { translate } from 'components/Translation';
import styles from 'assets/jss/material-dashboard-pro-react/components/simpleTableStyle';
import { makeStyles } from '@material-ui/core';
import classNames from 'classnames';
import { BodyS } from 'components/Typography/Typography';
import Row, { IColumn } from 'components/SimpleTable/Row';
import ConditionalRender from 'components/ConditionalRender/ConditionalRender';

// @ts-ignore
const useStyles = makeStyles(styles);

interface ISimpleTableProps {
	withCheckboxes?: boolean;
	idAccessor: string;
	columns: IColumn[];
	data: any[];
	selectedItems: Array<string | number>;
	setSelectedItems: (items: any[]) => void;
	striped?: boolean;
	loading?: boolean;
	header?: boolean;
	className?: string;
}

const SimpleTable = ({
	selectedItems,
	columns,
	setSelectedItems,
	withCheckboxes,
	data,
	idAccessor,
	striped,
	loading,
	className,
	header = true,
}: ISimpleTableProps) => {
	const classes = useStyles();
	const checkAll = () => {
		if (selectedItems.length === data.length) {
			setSelectedItems([]);
		} else {
			setSelectedItems(data.map((row) => row[idAccessor]));
		}
	};

	return (
		<div className={classNames(className, classes.tableWrapper)}>
			<div className={classes.table}>
				<ConditionalRender
					show={header}
					onTrue={() => (
						<div
							className={classNames({
								[classes.header]: true,
								[classes.whiteHeader]: striped,
							})}
						>
							{withCheckboxes && (
								<div className={classes.headerCheckboxWrapper}>
									{data.length > 3 && (
										<CustomCheckbox
											disableLabel
											disabled={data.length === 0}
											checked={selectedItems.length === data.length && data.length > 0}
											onClick={checkAll}
										/>
									)}
								</div>
							)}
							{columns.map((column, index) => (
								<div
									key={index}
									style={
										column.widthPercentage
											? { width: `${column.width}%` }
											: { minWidth: `${column.width}px`, maxWidth: `${column.width}px` }
									}
								>
									{column.header}
								</div>
							))}
						</div>
					)}
				/>

				<div
					className={classNames({
						[classes.body]: true,
						[classes.striped]: striped,
					})}
				>
					{data.map((row, index) => (
						<Row
							key={index}
							row={row}
							idAccessor={idAccessor}
							columns={columns}
							setSelectedItems={(value) => setSelectedItems(value)}
							selectedItems={selectedItems}
							withCheckboxes={!!withCheckboxes}
						/>
					))}
					{data.length <= 0 && (
						<div className={classes.noResults}>
							<BodyS color="secondary-light" disableMargin>
								{loading ? translate('loading') : translate('no.results')}
							</BodyS>
						</div>
					)}
				</div>
			</div>
		</div>
	);
};

export default SimpleTable;
